module.exports = __webpack_public_path__ + "img/menu-data-analytic.af234257.svg";